<script setup lang="ts">
import { useUserProfileStore } from '@/store/UserProfile';

const emit = defineEmits(["dismiss", "reviewed", "remind"]);



const { setReviewedApp, setRemindReviewApp, setNeverReviewApp } = useUserProfileStore();

interface Props {
    storeUrl: string;
}

const props = defineProps<Props>();

const leaveReview = () => {
    setReviewedApp();
    emit("reviewed");
    // Replace this with the URL where users can leave a review
    window.location.href = props.storeUrl;
}

const remindReview = () => {
    setRemindReviewApp();
}

const neverReview = () => {
    setNeverReviewApp();
}

</script>
<template>
    <div class="mt-5 pt-5">
        <h2 class="font-semibold text-xl text-center">Enjoying the app?</h2>
        <div class="mt-4 flex flex-col items-center justify-center">
            <a data-testid="review-link" class="text-action cursor-pointer" @click="leaveReview">
                <div class="flex">
                    <span class="mx-3 text-4xl">
                        <i class="far fa-star"></i>
                    </span>
                    <span class="mx-3 text-4xl">
                        <i class="far fa-star"></i>
                    </span>
                    <span class="mx-3 text-4xl">
                        <i class="far fa-star"></i>
                    </span>
                    <span class="mx-3 text-4xl">
                        <i class="far fa-star"></i>
                    </span>
                    <span class="mx-3 text-4xl">
                        <i class="far fa-star"></i>
                    </span>
                </div>
            </a>
        </div>
        <div class="mt-5 flex justify-center">
            <a data-testid="no-thanks-link" class="text-sm underline cursor-pointer" @click="neverReview">No Thanks</a>
        </div>
        <div class="mt-5 flex justify-center">
            <a data-testid="remind-me-link" class="text-sm underline cursor-pointer" @click="remindReview">Remind Me Later</a>
        </div>
    </div>
</template>